<template>
  <div class="base-nav">
    <div :class="['nav-item', {active: $route.path === item.urlNew}]" v-for="(item, i) in navList" :key="`baseNav${i}`" @click="handleClick(item)">
      <div class="normal">
        <img class="icon" :src="require(`../assets/nav/${item.icon}.png`)" alt="">
        <p>{{item.title}}</p>
      </div>
      <div class="nav-cur">
        <img class="icon_cur" :src="require(`../assets/nav/${item.icon}_cur.png`)" alt="">
        <span class="dot"></span>
      </div>
      <div v-if="item.icon === 'goods_cart' && goodsCartNum" class="custom-badge">{{goodsCartNum}}</div>
      <div v-if="item.icon === 'intention' && smCartNum" class="custom-badge">{{smCartNum}}</div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { baseNav as navList } from '@/utils/dict'
import { showLoading, hideLoading, showAlert } from '@/utils/tools'
import { mapState, mapGetters } from 'vuex'
import { checkLoginStatus, toShoppingMall, gioTracking } from '@/plugins/common'
export default {
  name: 'BaseNav',

  data () {
    return {
      navList
    }
  },

  computed: {
    ...mapState(['bindTicket', 'goodsCartNum', 'smCartNum', 'isMiniApp']),
    ...mapGetters(['isLogin'])
  },

  methods: {
    async handleClick ({ url, urlNew }) {
      if (this.$route.fullPath === urlNew && url === '/') this.$emit('clickIndex')
      if (!url || this.$route.fullPath === urlNew) return

      this.gioTrackingHandler(url)
      if (url === '/page_order_detail' || url === '/page_shopping_cart') {
        await checkLoginStatus()
        showLoading('加载中...')
        const { errCode, errMsg, data } = await api.checkOrderStatus()
        hideLoading()
        if (errCode === 0) {
          if (url === '/page_order_detail') {
            if (data.orderStatus === 1) {
              this.$router.push(url)
            } else {
              this.$router.push(url)
            }
          } else {
            if (data.orderStatus === 1 && !data.orderIsInChange) {
              await showAlert('您已有订单，请点击“我的”查看')
              this.$router.push('/page_order_detail')
            } else {
              this.$router.push(url)
            }
          }
        } else {
          showAlert(errMsg || '检查失败，请稍后重试')
        }
      } else if (url === 'shoppingcart') {
        // PCP商城
        await checkLoginStatus()
        showLoading('加载中...')
        // 10 购物车无内容，无订单,20 购物车有内容，订单未提交,30 购物车无内容，订单已提交,40 购物车有产品，订单修改中
        const { errCode, errMsg, data } = await api.getSMOrderState()
        hideLoading()
        if (errCode === 0) {
          if (data === 30) {
            await showAlert('您已有订单，请点击“我的”查看')
            toShoppingMall('order')
          } else {
            toShoppingMall('shoppingCart')
          }
        } else {
          showAlert(errMsg)
        }
      } else if (url === '/cruise') {
        if (this.isMiniApp) {
          // window.wx.miniProgram.navigateTo({ url: '/pages/cruise/search' })
          // window.wx.miniProgram.navigateTo({ url: '/pages/allRoutes/routes' })
          window.wx.miniProgram.navigateTo({ url: `${process.env.VUE_APP_MINI_PROGRAM_SEARCH}` })
        } else {
          window.location.href = 'https://mobile.rcclchina.com.cn/Rccl.Cruise/CruiseSearch/Search?offset=0'
        }
      } else {
        this.$router.push(url)
      }
    },
    gioTrackingHandler(url) {
      switch (url) {
        case '/':
          gioTracking('track','evt_ButtonClicked',{'btnType':'hp'}); break;
        case '/page_shopping_cart':
          gioTracking('track','evt_ButtonClicked',{'btnType':'cart'}); break;
        case 'shoppingcart':
          gioTracking('track','evt_ButtonClicked',{'btnType':'wish'}); break;
        case '/page_order_detail':
          gioTracking('track','evt_ButtonClicked',{'btnType':'personal'}); break;
        case '/cruise':
          gioTracking('track','evt_ButtonClicked',{'btnType':'cruiseSearch'}); break;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.base-nav {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 126px;
  padding: 0 16px;
  padding-bottom: 20px;
  box-sizing: border-box;
  box-shadow: 0 0 15px #e2e2e2;
  background-color: #fff;
  .nav-item {
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;
    text-align: center;
    font-size: 20px;
    color: #cfcfcf;
    line-height: 36px;
    &.active {
      .normal {
        opacity: 0;
      }
      .nav-cur {
        opacity: 1;
        top: -26px;
      }
      .custom-badge {
        transform: translate(20%, -13%);
      }
    }
    .normal {
      transition: all .3s;
    }
    .icon {
      display: block;
      width: 48px;
      height: 48px;
      margin: 0 auto;
    }
    .nav-cur {
      opacity: 0;
      position: absolute;
      top: 0;
      left: 50%;
      z-index: 1;
      width: 112px;
      margin-left: -56px;
      background: url("../assets/nav/cur_bg.png") 0 0 no-repeat;
      background-size: 100% auto;
      transition: all .3s;
      .icon_cur {
        display: block;
        width: 56px;
        margin: 20px auto 0;
      }
      .dot {
        display: block;
        width: 12px;
        height: 12px;
        margin: 15px auto 0;
        border-radius: 50%;
        background-color: @second-color;
      }
    }
  }
}
.custom-badge {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 3;
  box-sizing: border-box;
  min-width: 32px;
  padding: 0 6px;
  color: #fff;
  font-weight: 500;
  font-size: 18px;
  font-family: PingFang SC, Helvetica Neue, Arial, sans-serif;
  line-height: 32px;
  text-align: center;
  background-color: @error-color;
  border-radius: 16px;
  transform: translate(20%, 37%);
  transition: all .3s;
}
</style>
